import React, { useState } from "react";
import { Button, Card, Col, Form, Input, message, Row } from "antd";
import { MailOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../../../configs/FirebaseConfig";
import { login } from "../../../../urls";
import { useCmsUsers } from "../../../../data/hooks/firestore/useCmsUsers";

const backgroundStyle = {
  backgroundImage: "url(/img/others/img-17.jpg)",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
};

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { cmsUsers, isLoading: cmsUsersLoading } = useCmsUsers();

  const onSubmit = () => {
    form.validateFields().then((values) => {
      const { email } = values;
      setLoading(true);

      if (cmsUsersLoading) {
        message.warning(t("notifications.loading_users"));
        setLoading(false);
        return;
      }

      const cmsUser = cmsUsers.find((user) => user.userEmail === email);

      if (!!cmsUser) {
        sendPasswordResetEmail(auth, email)
          .then(() => {
            setLoading(false);
            form.resetFields();
            message.success(t("notifications.password_reset_send"));
          })
          .catch((err) => {
            setLoading(false);
            message.error(err.message);
          });
      } else {
        setLoading(false);
        message.warning(t("notifications.no_cms_user"));
      }
    });
  };

  return (
    <div className="h-100" style={backgroundStyle}>
      <div className="container d-flex flex-column justify-content-center h-100">
        <Row justify="center">
          <Col xs={20} sm={20} md={20} lg={9}>
            <Card>
              <div className="my-2">
                <div className="text-center">
                  <img className="img-fluid w-75" src="/img/logo.png" alt="" />
                  <h3 className="mt-3 font-weight-bold">{t("forgot_password")}</h3>
                  <p className="mb-4">{t("form.enter_email")}</p>
                </div>
                <Row justify="center">
                  <Col xs={24} sm={24} md={20} lg={20}>
                    <Form form={form} layout="vertical" name="forgot-password" onFinish={onSubmit}>
                      <Form.Item
                        name="email"
                        rules={[
                          {
                            required: true,
                            message: t("form.enter_email"),
                          },
                          {
                            type: "email",
                            message: t("form.enter_valid_email"),
                          },
                        ]}
                      >
                        <Input placeholder={t("email")} prefix={<MailOutlined className="text-primary" />} />
                      </Form.Item>
                      <Form.Item>
                        <Button loading={loading} type="primary" htmlType="submit" block>
                          {loading ? t("sending") : t("send")}
                        </Button>
                      </Form.Item>
                    </Form>
                    <Link to={login}>{t("login")}</Link>
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ForgotPassword;
